import { devToolsUnlocked } from './dev-tools';

// Dev-only: force the mobile-web "get the app" banner ON regardless of its real gate
// (the install probe, the iOS-Safari suppression, the narrow-width requirement) so it
// can be eyeballed in any environment — including the iOS Simulator's Safari, where the
// custom strip is normally suppressed in favour of Apple's native banner. Toggled from
// Dev Tools ▸ "Force app banner" (the brand-mark long-press menu).
//
// Gated on `devToolsUnlocked()` like every other dev lever: a real user's browser holds
// no grant, so this key sitting in their storage — or forged by hand — does nothing.
// Product-named (no `orion-web:` prefix), in a `symphony-dev:` namespace.
const KEY = 'symphony-dev:force-app-banner';

export function isAppBannerForced(): boolean {
  if (!devToolsUnlocked()) return false;
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function setAppBannerForced(on: boolean): void {
  try {
    if (on) window.localStorage.setItem(KEY, '1');
    else window.localStorage.removeItem(KEY);
  } catch {
    /* storage unavailable */
  }
}

/**
 * Honour a `?forceAppBanner=1` (or `=0`) query param, dev-gated: persists the flag so it
 * behaves exactly like the Dev Tools toggle from then on. Lets you flip the banner by
 * loading a URL on a device where the long-press menu is awkward — e.g. the iOS
 * Simulator's Safari. A real user's `?forceAppBanner=1` does nothing (no dev grant).
 */
export function applyAppBannerQueryOverride(): void {
  if (typeof window === 'undefined' || !devToolsUnlocked()) return;
  try {
    const v = new URLSearchParams(window.location.search).get('forceAppBanner');
    if (v === null) return;
    setAppBannerForced(v === '1' || v === 'true');
  } catch {
    /* ignore */
  }
}
